import { render, staticRenderFns } from "./IdentityAuthentication.vue?vue&type=template&id=5b59034b&scoped=true&"
import script from "./IdentityAuthentication.vue?vue&type=script&lang=js&"
export * from "./IdentityAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./IdentityAuthentication.vue?vue&type=style&index=0&id=5b59034b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59034b",
  null
  
)

export default component.exports